import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeComponent, GradientTextEnabler } from './styles';
const Badge = ({ className, children, borderColor = 'badgeBorder', backgroundColor = 'badgeBg', textColor = 'badgeText', }) => {
    return (_jsx(BadgeComponent, { className: className, "$borderColor": borderColor, "$backgroundColor": backgroundColor, "$textColor": textColor, children: _jsx(GradientTextEnabler, { "$textColor": textColor, children: children }) }));
};
export default Badge;
//# sourceMappingURL=index.js.map